import imgPropostaAceita from '@/assets/images/interpig-aceita.gif';
import { BusinessRules } from '../BusinessRules';

const rules: Partial<BusinessRules> = {
  imagemPropostaAceita: imgPropostaAceita,
  considerarFgtsNoResumoAcordo: true,
};

export default rules;
